
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.21 31.276a2.812 2.812 0 00-1.117-.233c-.884 0-1.724.423-2.255 1.13-3.975-2.045-4.876-3.508-4.961-8.382a80.56 80.56 0 004.895.15c2.042 0 4.116-.079 6.125-.237-1.432 2.391-2.443 5.219-2.687 7.572zm-1.117 4.409a1.823 1.823 0 01-1.467-2.9 1.806 1.806 0 011.467-.742c1.004 0 1.821.817 1.821 1.821a1.823 1.823 0 01-1.821 1.821zM4 17.998c0-.812 1.605-2.357 7.444-3.254v2.969l4.604.753c1.46.24 2.951.362 4.433.362h4.625c2.519 0 5.045-.261 7.509-.774l1.816-.379v-2.712c6.549.99 7.113 2.548 7.113 3.035 0 1.339-6.626 3.943-18.772 3.943C10.626 21.941 4 19.337 4 17.998zM22.938 4c5.145 0 9.493 2.715 9.493 5.931v1.399l-11.394.335c-.737.022-1.485.012-2.228-.027l-5.365-.285V9.931C13.444 6.715 17.792 4 22.938 4zm-9.494 8.355l5.312.282a28.506 28.506 0 002.31.028l11.365-.334v3.718l-.224.047a34.838 34.838 0 01-7.101.732h-4.625a25.45 25.45 0 01-4.109-.335l-2.928-.48v-3.658zm30.1 5.643c0-2.542-2.912-4.162-9.113-5.058V9.931C34.431 5.557 29.274 2 22.938 2c-6.337 0-11.494 3.557-11.494 7.931v2.795C3.683 13.866 2 16.202 2 17.998c0 3.281 6.954 5.126 14.877 5.723.09 5.336 1.157 7.101 5.514 9.347a2.789 2.789 0 00-.119.796 2.824 2.824 0 002.821 2.821c.109 0 .213-.019.319-.032l.04.108c1.02 2.749 1.635 4.41 3.575 5.85l.596-.803c-1.701-1.263-2.246-2.731-3.233-5.395l-.019-.048c.366-.189.684-.451.936-.774a17.304 17.304 0 006.846 1.402v-1c-2.215 0-4.358-.44-6.38-1.294.083-.266.141-.542.141-.835 0-.734-.289-1.4-.751-1.901.108-2.473 1.305-5.804 2.982-8.368 7.29-.708 13.399-2.522 13.399-5.597z"}})])
          )
        }
      }
    